import type { MimeType } from '../interface/mimeType';

const MIME_MAP: Record<MimeType, string> = {
    'Application/xml': 'vcproj',
    'application/PowerShell': 'psc1',
    'application/atom+xml': 'atom',
    'application/directx': 'x',
    'application/envoy': 'evy',
    'application/etl': 'etl',
    'application/fractals': 'fif',
    'application/fsharp-script': 'fsx',
    'application/futuresplash': 'spl',
    'application/hta': 'hta',
    'application/internet-property-stream': 'acx',
    'application/java-archive': 'jar',
    'application/json': 'json',
    'application/liquidmotion': 'jcz',
    'application/mac-binhex40': 'hqx',
    'application/ms-vsi': 'vsi',
    'application/msaccess': 'mde',
    'application/msaccess.addin': 'accda',
    'application/msaccess.cab': 'accdc',
    'application/msaccess.ftemplate': 'accft',
    'application/msaccess.runtime': 'accdr',
    'application/msaccess.webapplication': 'accdw',
    'application/msword': 'wiz',
    'application/octet-stream': 'xtp',
    'application/oda': 'oda',
    'application/oleobject': 'ods',
    'application/olescript': 'axs',
    'application/onenote': 'onepkg',
    'application/opensearchdescription+xml': 'osdx',
    'application/pdf': 'pdf',
    'application/pics-rules': 'prf',
    'application/pkcs10': 'p10',
    'application/pkcs7-mime': 'p7c',
    'application/pkcs7-signature': 'p7s',
    'application/pkix-crl': 'crl',
    'application/postscript': 'ps',
    'application/rat-file': 'rat',
    'application/rtf': 'rtf',
    'application/sdp': 'sdp',
    'application/set-payment-initiation': 'setpay',
    'application/set-registration-initiation': 'setreg',
    'application/streamingmedia': 'ssm',
    'application/vnd.adobe.air-application-installer-package+zip': 'air',
    'application/vnd.fdf': 'fdf',
    'application/vnd.ms-excel': 'xlm',
    'application/vnd.ms-excel.addin.macroEnabled.12': 'xlam',
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12': 'xlsb',
    'application/vnd.ms-excel.sheet.macroEnabled.12': 'xlsm',
    'application/vnd.ms-excel.template.macroEnabled.12': 'xltm',
    'application/vnd.ms-mediapackage': 'mpf',
    'application/vnd.ms-office.calx': 'calx',
    'application/vnd.ms-officetheme': 'thmx',
    'application/vnd.ms-pki.certstore': 'sst',
    'application/vnd.ms-pki.pko': 'pko',
    'application/vnd.ms-pki.seccat': 'cat',
    'application/vnd.ms-pki.stl': 'stl',
    'application/vnd.ms-powerpoint': 'pot',
    'application/vnd.ms-powerpoint.addin.macroEnabled.12': 'ppam',
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12': 'pptm',
    'application/vnd.ms-powerpoint.slide.macroEnabled.12': 'sldm',
    'application/vnd.ms-powerpoint.slideshow.macroEnabled.12': 'ppsm',
    'application/vnd.ms-powerpoint.template.macroEnabled.12': 'potm',
    'application/vnd.ms-project': 'mpp',
    'application/vnd.ms-visio.viewer': 'vdx',
    'application/vnd.ms-word.document.macroEnabled.12': 'docm',
    'application/vnd.ms-word.template.macroEnabled.12': 'dotm',
    'application/vnd.ms-works': 'wdb',
    'application/vnd.ms-wpl': 'wpl',
    'application/vnd.ms-xpsdocument': 'xps',
    'application/vnd.oasis.opendocument.presentation': 'odp',
    'application/vnd.oasis.opendocument.text': 'odt',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
    'application/vnd.openxmlformats-officedocument.presentationml.slide': 'sldx',
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow': 'ppsx',
    'application/vnd.openxmlformats-officedocument.presentationml.template': 'potx',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template': 'xltx',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template': 'dotx',
    'application/vnd.rn-realmedia': 'rm',
    'application/vnd.rn-rn_music_package': 'rmp',
    'application/vnd.visio': 'vtx',
    'application/vnd.wap.wmlc': 'wmlc',
    'application/vnd.wap.wmlscriptc': 'wmlsc',
    'application/vsix': 'vsix',
    'application/windows-library+xml': 'librar-ms',
    'application/windows-search-connector+xml': 'searchConnecto-ms',
    'application/winhlp': 'hlp',
    'application/wlmoviemaker': 'WLMP',
    'application/x-7z-compressed': '7z',
    'application/x-bcpio': 'bcpio',
    'application/x-bridge-url': 'adobebridge',
    'application/x-cdf': 'cdf',
    'application/x-compress': 'z',
    'application/x-compressed': 'tgz',
    'application/x-cpio': 'cpio',
    'application/x-csh': 'csh',
    'application/x-director': 'dir',
    'application/x-dvi': 'dvi',
    'application/x-gtar': 'gtar',
    'application/x-hdf': 'hdf',
    'application/x-internet-signup': 'isp',
    'application/x-iphone': 'iii',
    'application/x-itunes-ipa': 'ipa',
    'application/x-itunes-ipg': 'ipg',
    'application/x-itunes-ipsw': 'ipsw',
    'application/x-itunes-ite': 'ite',
    'application/x-itunes-itlp': 'itlp',
    'application/x-itunes-itms': 'itms',
    'application/x-itunes-itpc': 'itpc',
    'application/x-java-applet': 'class',
    'application/x-java-jnlp-file': 'jnlp',
    'application/x-javascript': 'js',
    'application/x-latex': 'latex',
    'application/x-miva-compiled': 'mvc',
    'application/x-mmxp': 'mxp',
    'application/x-mpeg': 'amc',
    'application/x-mpegURL': 'm3u8',
    'application/x-ms-application': 'application',
    'application/x-ms-license': 'slupk-ms',
    'application/x-ms-manifest': 'manifest',
    'application/x-ms-reader': 'lit',
    'application/x-ms-vsto': 'vsto',
    'application/x-ms-wmd': 'wmd',
    'application/x-ms-xbap': 'xbap',
    'application/x-msaccess': 'mdb',
    'application/x-mscardfile': 'crd',
    'application/x-msclip': 'clp',
    'application/x-msdownload': 'dll',
    'application/x-msmediaview': 'mvb',
    'application/x-msmetafile': 'wmf',
    'application/x-mspublisher': 'pub',
    'application/x-msterminal': 'trm',
    'application/x-mswrite': 'wri',
    'application/x-netcdf': 'nc',
    'application/x-oleobject': 'hhc',
    'application/x-perfmon': 'pmw',
    'application/x-pkcs12': 'pfx',
    'application/x-pkcs7-certificates': 'spc',
    'application/x-pkcs7-certreqresp': 'p7r',
    'application/x-podcast': 'pcast',
    'application/x-quicktimeplayer': 'qtl',
    'application/x-safari-safariextz': 'safariextz',
    'application/x-safari-webarchive': 'webarchive',
    'application/x-sgimb': 'sgimb',
    'application/x-sh': 'sh',
    'application/x-shar': 'shar',
    'application/x-shockwave-flash': 'swf',
    'application/x-silverlight-app': 'xap',
    'application/x-smaf': 'mmf',
    'application/x-stuffit': 'sit',
    'application/x-sv4cpio': 'sv4cpio',
    'application/x-sv4crc': 'sv4crc',
    'application/x-tar': 'tar',
    'application/x-tcl': 'tcl',
    'application/x-tex': 'tex',
    'application/x-texinfo': 'texi',
    'application/x-troff': 'roff',
    'application/x-troff-man': 'man',
    'application/x-troff-me': 'me',
    'application/x-troff-ms': 'ms',
    'application/x-ustar': 'ustar',
    'application/x-wais-source': 'src',
    'application/x-wlpg-detect': 'wlpginstall',
    'application/x-wlpg3-detect': 'wlpginstall3',
    'application/x-x509-ca-cert': 'der',
    'application/x-zip-compressed': 'zip',
    'application/xaml+xml': 'xaml',
    'application/xhtml+xml': 'xht',
    'application/xml': 'xml',
    'application/zip': 'zip',
    'audio/aac': 'aac',
    'audio/ac3': 'ac3',
    'audio/aiff': 'cdda',
    'audio/audible': 'aa',
    'audio/basic': 'snd',
    'audio/m4a': 'm4a',
    'audio/m4b': 'm4b',
    'audio/m4p': 'm4p',
    'audio/mid': 'midi',
    'audio/scpls': 'pls',
    'audio/ogg': 'opus',
    'audio/opus': 'opus',
    'audio/vnd.audible.aax': 'aax',
    'audio/vnd.dlna.adts': 'ADT',
    'audio/wav': 'wav',
    'audio/x-aiff': 'aif',
    'audio/x-caf': 'caf',
    'audio/x-gsm': 'gsm',
    'audio/x-m4r': 'm4r',
    'audio/x-mpegurl': 'm3u',
    'audio/x-ms-wax': 'wax',
    'audio/x-pn-realaudio': 'ra',
    'audio/x-pn-realaudio-plugin': 'rpm',
    'audio/x-sd2': 'sd2',
    'audio/x-smd': 'smz',
    'drawing/x-dwf': 'dwf',
    'application/x-gzip': 'gz',
    'image/avif': 'avif',
    'image/bmp': 'bmp',
    'image/cis-cod': 'cod',
    'image/gif': 'gif',
    'image/ief': 'ief',
    'image/jpeg': 'jpeg',
    'image/jpg': 'jpeg',
    'image/pict': 'pct',
    'image/pjpeg': 'jfif',
    'image/png': 'png',
    'image/tiff': 'tiff',
    'image/vnd.ms-photo': 'wdp',
    'image/vnd.rn-realflash': 'rf',
    'image/vnd.wap.wbmp': 'wbmp',
    'image/webp': 'webp',
    'image/x-cmu-raster': 'ras',
    'image/x-cmx': 'cmx',
    'image/x-icon': 'ico',
    'image/x-jg': 'art',
    'image/x-macpaint': 'pntg',
    'image/x-portable-anymap': 'pnm',
    'image/x-portable-bitmap': 'pbm',
    'image/x-portable-graymap': 'pgm',
    'image/x-portable-pixmap': 'ppm',
    'image/x-quicktime': 'qti',
    'image/x-rgb': 'rgb',
    'image/x-xbitmap': 'xbm',
    'image/x-xpixmap': 'xpm',
    'image/x-xwindowdump': 'xwd',
    'message/rfc822': 'nws',
    'application/x-msmoney': 'mny',
    'audio/mpeg': 'mp3',
    'application/x-msschedule': 'scd',
    'text/scriptlet': 'sct',
    'text/css': 'css',
    'text/csv': 'csv',
    'text/dlm': 'dlm',
    'text/h323': '323',
    'text/html': 'html',
    'text/iuls': 'uls',
    'text/jscript': 'jsx',
    'text/plain': 'odl',
    'text/richtext': 'rtx',
    'text/sgml': 'sgml',
    'text/tab-separated-values': 'tsv',
    'text/vbscript': 'vbs',
    'text/vnd.wap.wmlscript': 'wmls',
    'text/webviewhtml': 'htt',
    'text/x-component': 'htc',
    'text/x-hdml': 'hdml',
    'text/x-html-insertion': 'qht',
    'text/x-ms-contact': 'contact',
    'text/x-ms-group': 'group',
    'text/x-ms-iqy': 'iqy',
    'text/x-ms-odc': 'odc',
    'text/x-ms-rqy': 'rqy',
    'text/x-setext': 'etx',
    'text/x-vcard': 'vcf',
    'text/xml': 'vssettings',
    'video/AV1': 'av1',
    'video/vnd.dlna.mpeg-tts': 'tts',
    'video/3gpp': '3gp',
    'video/3gpp2': '3g2',
    'video/quicktime': 'qt',
    'video/mp4': 'mp4',
    'video/mpeg': 'mpeg',
    'video/x-dv': 'dif',
    'video/x-flv': 'flv',
    'video/x-ivf': 'IVF',
    'video/x-la-asf': 'lsf',
    'video/x-m4v': 'm4v',
    'video/x-matroska': 'mkv',
    'video/x-ms-asf': 'asr',
    'video/x-ms-wm': 'wm',
    'video/x-ms-wmv': 'wmv',
    'video/x-ms-wvx': 'wvx',
    'video/x-msvideo': 'avi',
    'video/x-sgi-movie': 'movie',
    'video/webm': 'webm',
    'audio/x-ms-wma': 'wma',
    'text/vnd.wap.wml': 'wml',
    'video/x-ms-wmp': 'wmp',
    'video/x-ms-wmx': 'wmx',
    'vnd.apple.mpegURL': 'm3u8',
    'application/x-ms-wmz': 'wmz',
    'x-world/x-vrml': 'flr',
} as const;

function mimeTypeToFileExtension(mime: MimeType): string | null {
    return MIME_MAP[mime];
}

function fileExtensionToMimeType(filePathInput: string): MimeType | null {
    let fileExtensionSearch = filePathInput.toLowerCase();

    /* If we were given move than the extension, remove anything before the last '.' */
    if (fileExtensionSearch.includes('.')) {
        fileExtensionSearch = fileExtensionSearch.split('.').at(-1) ?? fileExtensionSearch;
    }

    const searchList = Object.entries(MIME_MAP) as [MimeType, string][];

    const match = searchList.find(
        ([_, fileExtensionCmp]) => fileExtensionCmp === fileExtensionSearch,
    );

    return match?.[0] ?? null;
}

function isMimeType(object: unknown): object is MimeType {
    if (object === null || object === undefined || typeof object !== 'string') {
        return false;
    }

    const typeLookup = object as MimeType;

    return Boolean(MIME_MAP[typeLookup]);
}

function mimeType() {
    return {
        fileExtensionToMimeType,
        mimeTypeToFileExtension,
        isMimeType,
    };
}

export default mimeType;
